{
  "INTEGRATION_APPS": {
    "FETCHING": "S'estan obtenint integracions",
    "NO_HOOK_CONFIGURED": "No hi ha integracions {integrationId} configurades en aquest compte.",
    "HEADER": "Aplicacions",
    "STATUS": {
      "ENABLED": "Habilita",
      "DISABLED": "Inhabilita"
    },
    "CONFIGURE": "Configura",
    "ADD_BUTTON": "Afegeix un nou hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirma la supressió",
        "ACCOUNT": "Desconnecta"
      },
      "MESSAGE": {
        "INBOX": "N'estàs segur?",
        "ACCOUNT": "Segur que us desconnecteu?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Si, esborra",
        "ACCOUNT": "Sí, desconnecta"
      },
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "API": {
        "SUCCESS_MESSAGE": "S'ha esborrat el Hook correctament",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
      }
    },
    "LIST": {
      "FETCHING": "Recollint els hooks d'integració",
      "INBOX": "Safata d'entrada",
      "EDIT": {
        "BUTTON_TEXT": "Edita"
      },
      "DELETE": {
        "BUTTON_TEXT": "Esborrar"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Selecciona Safata d'entrada",
          "PLACEHOLDER": "Selecciona Safata d'entrada"
        },
        "SUBMIT": "Crear",
        "CANCEL": "Cancel·la"
      },
      "API": {
        "SUCCESS_MESSAGE": "El hook d'integració s'ha afegit correctament",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
      }
    },
    "EDIT": {
      "TITLE": "Edita {name}",
      "FORM": {
        "SUBMIT": "Actualitza",
        "CANCEL": "Cancel·la"
      },
      "API": {
        "SUCCESS_MESSAGE": "El hook d'integració s'ha actualitzat correctament",
        "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor de xat. Torna-ho a provar més endavant"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connectar"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Desconnecta"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sincronitza correus i xats web amb el teu compte de Daktela.",
      "RETINO": "Retino posa ordre a la gestió de devolucions i reclamacions.",
      "MAILSHIP": "Mailship és un sistema de gestió de magatzem i compliment de comandes. Consulta l'estat de les comandes, el seguiment i els detalls d'expedició.",
      "RAYNET": "Connecteu el vostre compte de Raynet CRM per accedir a les dades dels clients. Afegiu una connexió amb el vostre nom d'usuari i token d'API de Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Prova la connexió",
      "SUCCESS": "Connexió correcta",
      "ERROR": "La connexió ha fallat. Comproveu les vostres credencials."
    }
  }
}
